import { render } from "./collage.vue?vue&type=template&id=7802536c&lang=true"
import script from "./collage.vue?vue&type=script&lang=js"
export * from "./collage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__